import { Text } from "@/components/ui/text";

type ExploreReportKpiProps = {
  label: string;
  value: number;
};

export function ExploreReportKpi({ label, value }: ExploreReportKpiProps) {
  const formatted = Number.isInteger(value)
    ? value.toLocaleString()
    : value.toLocaleString(undefined, { maximumFractionDigits: 2 });

  return (
    <div className="flex shrink-0 flex-col items-center justify-center border-b bg-background px-6 py-8">
      <Text size="1" muted className="truncate">
        {label}
      </Text>
      <p className="mt-2 text-4xl font-semibold tabular-nums">{formatted}</p>
    </div>
  );
}
